// extracted by mini-css-extract-plugin
export default {"content":"PhoneCallNoticePopup_content__OzdVM","dateContainer":"PhoneCallNoticePopup_dateContainer__VOCTO","label":"PhoneCallNoticePopup_label__D5PDC"};